module.exports = __webpack_public_path__ + "img/cat.287d771b.png";